import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;

  min-height: calc(100vh-50px);
`;

export const MobileMenuIcon = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`;

export const DesktopMenuButtons = styled.div`
  @media (max-width: 767px) {
    display: none;
  }
`;
